<template>
    <v-main>
      <div id="app">

          <Timeline></Timeline>

          <div class="happenings">
          <v-card shaped class="rounded-xl" max-width="500"
                flat
                color="#383838"
                elevation="0"
                >
            <v-card-text>
              <h3>What else happened in {{ year }}?</h3>
            </v-card-text>
          </v-card>

          <div class="grid-container">
            <div 
              class="grid-item misc-event"
              v-for="(event, i) in happenings"
              :key="i"
              v-show="(year == happenings[i].year) && happenings[i].event"
            >
              <v-card 
                  shaped class="rounded-xl" 
                  min-width="350"
                  min-height="125"
                  flat
                  color="#535353"
                  elevation="0"
                  >
                <v-card-text span style="line-height: 1.3;">
                  <div class="eventText">
                    <p style="display: flex">{{ happenings[i].event }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
          </div>
      </div>
    </v-main>
</template>

<script>
  import miscEvents from '@/content/additionalEvents.js'
  import Timeline from '@/components/Timeline';

  export default {
    name: 'YearDetail',

    components:{
      Timeline, 
    },

    props: ['year'],

    methods: {

    },

    mounted() {
      window.scrollTo(1000,0);
      window.scrollTo(0,0);
    },

    data() {
      return{
        happenings: miscEvents.events,
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/styles/year-style.css";
</style>
